// removed by extract-text-webpack-plugin
module.exports = {"form":"addPlayer__form___2Ehga","button":"addPlayer__button___q90Sz","input":"addPlayer__input___35kcv"};


//////////////////
// WEBPACK FOOTER
// ./components/AddPlayer/addPlayer.css
// module id = 269
// module chunks = 0